import { NgModule } from '@angular/core';
import { NgArrayPipesModule } from './pipes/array/index';
import { NgObjectPipesModule } from './pipes/object/index';
import { NgStringPipesModule } from './pipes/string/index';
import { NgMathPipesModule } from './pipes/math/index';
import { NgBooleanPipesModule } from './pipes/boolean/index';
var NgPipesModule = (function () {
    function NgPipesModule() {
    }
    NgPipesModule.decorators = [
        { type: NgModule, args: [{
                    exports: [NgArrayPipesModule, NgStringPipesModule, NgMathPipesModule, NgBooleanPipesModule, NgObjectPipesModule]
                },] },
    ];
    /** @nocollapse */
    NgPipesModule.ctorParameters = function () { return []; };
    return NgPipesModule;
}());
export { NgPipesModule };
export * from './pipes/array/index';
export * from './pipes/object/index';
export * from './pipes/string/index';
export * from './pipes/math/index';
export * from './pipes/boolean/index';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/index.js
// module id = 219
// module chunks = 4